import signImg from '../../assets/images/Login.jpg'
import logo from '../../assets/images/h_logo.png'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import React, { useState, useEffect } from "react";
import { API_STATUS } from '../../constants';
import { loginApi } from '../../apis/login/user_login';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { remove_user_login, set_user_login } from '../../redux/VerifyLogin';
import SetLoginToken from '../../utils/setlogintoken';
import { FgtUsernameApi } from '../../apis/login/fgt_username_api';

export default function RetUsername() {

    const dispatch = useDispatch();
    const authState = useSelector(state => state.checkuserlogin);
    const navigate = useNavigate();

    const [login, setLogin] = useState(API_STATUS);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [email, setEmail] = useState('');

    useEffect(() => {
        if (authState.isLogin) {
            navigate('/');
        }
    }, [authState]);

    useEffect(() => {
        if (!login.isError && !login.isLoader) {
            if (login.data != null) {
                const res = login.data;

                if (res['status'] === 1) {
                    setSuccess(true);
                } else {
                    setErrMsg("Email id not found");
                }
            }
        } else if (login.isError) {
            setErrMsg("Network error");
        }
    }, [login]);


    const SignupSchema = Yup.object().shape({
        username: Yup.string()
            .min(4, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Enter email id').email('Incorrect email id')
    });

    return <div>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" />

        <div className="container px-4 text-center">
            <div className="row justify-content-center pb-100 pt-100">
                <div className="col-md-4 d-none d-md-block">
                    <img src={signImg} alt='' width={450} />
                </div>
                <div className="col-md-4">
                    <Formik
                        initialValues={{
                            username: "",
                            password: "",
                        }}
                        validationSchema={SignupSchema}
                        onSubmit={values => {
                            let body = values;
                            setEmail(body.username);
                            setErrMsg('');
                            FgtUsernameApi(body, setLogin);
                        }}
                    >
                        {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                            <div className="card bg-white shadow py-3">
                                <div className="card-body">
                                    <div className="row justify-content-center" style={{ paddingBottom: 20 }}>
                                        <img src={logo} alt='' style={{ width: 275 }} />
                                    </div>
                                    {
                                        errMsg !== "" &&
                                        <div className='alert text-danger' style={{ textAlign: 'left' }}>
                                            <strong>Failed !!</strong><br />
                                            {errMsg}
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                            <div className="text-lg">Forgot Username ?</div>
                                            {
                                                !success &&
                                                <div className="text-sm">Enter registered email id to retrive your username.</div>
                                            }
                                            {
                                                success &&
                                                <div className="text-md text-green-500">Thank you for your request, your login username is sent to {email} id. Please check email.</div>
                                            }
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">

                                            <div className="contact-field">
                                                <Field className="form-control" type="email" name="username" placeholder="Email id*" />
                                            </div>
                                            {
                                                errors.username && touched.username &&
                                                <div className='text-danger'>{errors.username}</div>
                                            }
                                        </div>

                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            {
                                                login.isLoader &&
                                                <div className="spinner-border text-primary" role="status">
                                                </div>
                                            }
                                            {
                                                !login.isLoader &&

                                                <button
                                                    onClick={() => {
                                                        if (!isValid) {
                                                            setFieldTouched('username');
                                                        } else {
                                                            handleSubmit();
                                                        }
                                                    }}
                                                    type="button" className="button_slide slide_right orange" style={{ width: '100%' }}>Submit</button>
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </Formik>
                    <br />

                    <div className="card bg-white shadow py-3">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">

                                    <p style={{ color: '#969696' }}>Back to <a style={{ color: '#0d6efd' }} href="/login">Login</a> </p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
}